import {useState} from "react";
import {postJson} from "../util/apiUtils";
import Turnstile from "react-turnstile";
import { CAPTCHA_SITE_KEY } from "../util/config";

export default function MessageForm() {

    const [messageForm, setMessageForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: ""
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);

    const [captchaToken, setCaptchaToken] = useState(null);

    const validateMessageForm = () => {

        const newErrors = {};

        if (!messageForm.firstName.trim()) {
            newErrors.firstName = "First name is required";
        }

        if (!messageForm.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(messageForm.email)) {
            newErrors.email = "Invalid email format";
        }

        if (!messageForm.message.trim()) {
            newErrors.message = "Message is required";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };


    const handleChange = (e) => {

        const { name, value } = e.target;

        setMessageForm(prev => ({
            ...prev,
            [name]: value
        }));

        // Remove error when user fixes field
        if (value.trim()) {
            setErrors(prev => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };


    const onSubmitMessage = async () => {

        if (!captchaToken) {
            return;
        }

        if (!validateMessageForm()) return;

        try {
            setIsSubmitting(true);
            setSubmitSuccess(false);

            await postJson("/message", messageForm,
                {
                    "X-Captcha-Token": captchaToken
                });

            setSubmitSuccess(true);

            // Reset form
            setMessageForm({
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                message: ""
            });

        } catch (error) {
            console.error(error);
            alert("Failed to submit message. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const inputClass = (field) => `
    w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2
    ${errors[field]
        ? "border-red-500 bg-red-50 focus:ring-red-400"
        : "border-gray-300 focus:ring-[#2f855a]"
    }`;

    return (
        <div>

            <h3 className="text-2xl text-gray-800 mb-6 mt-6">
                Have a question?
            </h3>

            <div className="space-y-4">

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    <div>
                        <label className="block text-sm font-medium mb-1">First Name</label>
                        <input name="firstName"
                               value={messageForm.firstName}
                               onChange={handleChange}
                               type="text"
                               className={inputClass("firstName")}/>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-1">Last Name</label>
                        <input name="lastName"
                               value={messageForm.lastName}
                               onChange={handleChange}
                               type="text"
                               className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#2f855a]"/>
                    </div>

                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    <div>
                        <label className="block text-sm font-medium mb-1">Email</label>
                        <input type="email"
                               name="email"
                               value={messageForm.email}
                               onChange={handleChange}
                               className={inputClass("email")}/>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-1">Phone Number</label>
                        <input type="tel"
                               name="phone"
                               value={messageForm.phone}
                               onChange={handleChange}
                               className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#2f855a]"/>
                    </div>

                </div>

                <div>
                    <label className="block text-sm font-medium mb-1">Message</label>
                    <textarea rows="4"
                              name="message"
                              value={messageForm.message}
                              onChange={handleChange}
                              className={inputClass("message")}></textarea>
                </div>

                {submitSuccess && (
                    <div className="text-[#1C3353] text-sm">
                        Message successfully sent!
                    </div>
                )}

                {!submitSuccess && (
                    <div className="flex flex-col xl:flex-row lg:items-center gap-2">
                        <button
                            onClick={onSubmitMessage}
                            disabled={isSubmitting}
                            className="inline-block bg-gradient-to-b from-[#F6D28B] to-[#F1C169] text-[#1C3353] text-[17px] font-semibold px-5 py-2 rounded-lg shadow-md whitespace-nowrap transition-all disabled:opacity-50"
                        >
                            {isSubmitting ? "Sending..." : "Submit Message"}
                        </button>

                        <div className="flex justify-center lg:justify-start">
                            <Turnstile
                                sitekey={CAPTCHA_SITE_KEY}
                                theme="light"
                                action="contact_form"
                                onVerify={(token) => setCaptchaToken(token)}
                                onExpire={() => setCaptchaToken(null)}
                                onError={() => setCaptchaToken(null)}
                            />
                        </div>

                        </div>

                        )}


                    </div>

                    </div>
                    );
                }
